import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
  CREATE_METER_SUCCESS,
  FETCH_METER_SUCCESS,
  GET_METER_SUCCESS,
  SAVE_METER_QUERY,
  FETCH_ASSET_METER_DETAIL_SUCCESS
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {
  fetchError,
  fetchFilter,
  fetchStart,
  fetchSubElementFilter,
  fetchSuccess,
  fetchSuperMasterFilter
} from "./Common";
import { getUser } from "./Auth";
import { message } from "antd";
import { arrayToCSV, downloadCSV, downloadJSONFile } from "../../util/methods";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_METER_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_METER_QUERY,
    query
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_METER_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_METER_SUCCESS,
    data
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { meter } = store.getState();
      const { query } = meter;
      const response = await axios.get(`/meter?${generateQueryString(query)}`);

      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { meter } = store.getState();
      const { query } = meter;
      const response = await axios.get(`/meter/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload, redirect = true, module, subMaster = false, superMaster = false) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/meter`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
        dispatch(fetchSuccess());
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({ data: response.data }));

        if (redirect) {
          history.push('/meter');
          dispatch(getResource());
        }
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.put(`/meter/${id}`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/meter');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

export const advanceInstallationDate = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.put(`/meter/${id}/advance-installation-date`, payload);
      if (response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/meter');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      const msg = error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'Failed to advance installation date';
      message.error(msg);
      dispatch(fetchError(msg));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/meter/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/meter/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getAssetMeterDetail = (asset, dateTime = 0) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/meter/asset/${asset}/date/${dateTime}`);
      // console.log("response****:", response.data);
      dispatch(fetchSuccess());
      dispatch(fetchAssetMeterDetailSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

// export const getAssetMeterDetailWithDateTime = (asset, dateTime) => {
//   return async (dispatch) => {
//     dispatch(fetchStart());
//     try {
//       const response = await axios.get(`/meter/asset/${asset}/date/${dateTime}`);
//       dispatch(fetchSuccess());
//       dispatch(fetchAssetMeterDetailSuccess({ data: response.data }));
//     } catch (error) {
//       dispatch(fetchError(error.response.data.message));
//       console.log("Error****:", error.response.data.message);
//     }
//   }
// };

export const fetchAssetMeterDetailSuccess = ({ data }) => {
  return {
    type: FETCH_ASSET_METER_DETAIL_SUCCESS,
    data
  };
};

export const meterImport = (payload) => {
  return async (dispatch) => {
    dispatch(fetchStart())
    try {
      let formData = new FormData()
      formData.append('organisation', payload.organisation)
      formData.append('files', payload.file)

      const response = await axios.post(`/meter/admin-bulk-upload`, formData, {
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })

      dispatch(fetchSuccess())
      if (response && response.data) {
        const { data } = response

        // Download the response as JSON file
        downloadJSONFile({
          data: JSON.stringify(data, null, 1),
          fileName: 'meter-import-' + new Date().getTime() + '.json',
          fileType: 'text/json',
        })

        // Show success alert
        message.success('Check the logs for the import status!')
      } else {
        message.error('Import failed. Please check your data and try again.')
      }
    } catch (error) {
      dispatch(fetchError(error))
      console.log("Error****:", error)
      message.error(error.response.data.message || 'Import failed. Please try again.')
    }
  }
}
